import { useState, useEffect } from "react";

/**
 * Custom hook for mobile detection
 *
 * Criteria:
 * - Only considers phones as mobile (tablets excluded)
 * - Only portrait mode counts as mobile
 * - Landscape mode = desktop view
 *
 * @returns {{ isMobile: boolean }}
 */
export const useMobileDetection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      // 1. Must be in portrait mode
      const isPortrait = height > width;

      // 2. Phone size check (width less than 480px)
      const isPhoneSize = width <= 480;

      // Device is mobile only if ALL three conditions are true
      const isMobileDevice = isPortrait && isPhoneSize;

      setIsMobile(isMobileDevice);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);
    window.addEventListener("orientationchange", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("orientationchange", checkMobile);
    };
  }, []);

  return { isMobile };
};
